import AnalyticsHelper from '../../utils/analytics-helper';

export default class ExtrasModal {
    constructor(parent) {
        this.parent = parent;
        this.modals = [...this.parent.el.querySelectorAll('.configurator--extras-modal')];
        this.close = [...this.parent.el.querySelectorAll('.configurator--extras-modal .modal-close')];
        this.extraFeatureLinks = [...this.parent.el.querySelectorAll('.extra-features-link')];
        this.bind();
    }

    bind() {
        this.modals.forEach((l) => l.addEventListener('click', (e) => {
            if (!e.target.closest('.modal-container')) {
                e.preventDefault();
                e.stopPropagation();
                const modal = e.target.closest('.configurator--extras-modal');
                modal.close();
            }
        }));

        this.close.forEach((l) => l.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const modal = e.target.closest('.configurator--extras-modal');
            if(modal) {
                modal.close();
            }
        }));

        this.extraFeatureLinks.forEach((l) => l.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            AnalyticsHelper.push(l);
            this.show(e.currentTarget.dataset.id);
        }));
    }

    show(modalId) {
        const modal = this.modals.find((m) => m.id === modalId);
        if(modal){
            modal.showModal();
            modal.querySelector('.modal-close').focus({ preventScroll: true });
        }
    }
}
